import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "@aws-amplify/ui-vue";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Amplify, * as AmplifyModules from "aws-amplify";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { AmplifyPlugin } from "aws-amplify-vue";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import awsmobile from "./aws-exports";

// css
import "startbootstrap-sb-admin-2/vendor/fontawesome-free/css/all.min.css";
import "startbootstrap-sb-admin-2/vendor/bootstrap/scss/bootstrap.scss";
import "startbootstrap-sb-admin-2/css/sb-admin-2.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

// js
import "startbootstrap-sb-admin-2/vendor/jquery/jquery.min.js";
import "startbootstrap-sb-admin-2/vendor/jquery-easing/jquery.easing.min.js";
import "startbootstrap-sb-admin-2/vendor/bootstrap/js/bootstrap.bundle.min.js";
import "./vendor/sb-admin-2.js";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Amplify.configure(awsmobile);
Vue.use(AmplifyPlugin, AmplifyModules);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
